import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiMapPin, FiNavigation, FiInfo } = FiIcons;

const TravelDetails = () => {
  return (
    <section id="travel-details" className="py-10 md:py-16 bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            รายละเอียดการเดินทาง
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            ข้อมูลสำคัญสำหรับการเดินทางมายังจุดนัดพบ
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-8 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752688267466-srichank-trip-%C3%A0%C2%B9%C2%80%C3%A0%C2%B8%C2%81%C3%A0%C2%B8%C2%B2%C3%A0%C2%B8%C2%B0%C3%A0%C2%B8%C2%A5%C3%A0%C2%B8%C2%AD%C3%A0%C2%B8%C2%A2.png"
                alt="ท่าเรือเกาะลอย - จุดนัดพบ"
                className="w-full h-[400px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-2xl font-bold mb-2">ท่าเรือเกาะลอย</h3>
                <p className="text-lg opacity-90">จุดนัดพบสำหรับการเดินทาง</p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
                  <SafeIcon icon={FiMapPin} className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900">จุดนัดพบ</h3>
              </div>

              <div className="space-y-4">
                <p className="text-lg text-gray-700 font-semibold">
                  ท่าเรือ "เกาะลอย" ศรีราชา
                </p>
                <p className="text-gray-600 leading-relaxed">
                  กรุณามาถึงจุดนัดพบเวลา 10:20 น. ตามวันและเวลาที่กำหนด
                </p>
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <p className="text-blue-800 font-medium">
                    เกาะลอย คือ จุดนัดพบรอขึ้นเรือเพื่อไปไหว้เจ้าพ่อเขาใหญ่ เกาะสีชัง
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-8">
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-green-600 rounded-lg flex items-center justify-center">
                  <SafeIcon icon={FiNavigation} className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900">การเดินทาง</h3>
              </div>

              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0" />
                  <p className="text-gray-700">
                    <span className="font-semibold">สำหรับคนไม่มีรถ:</span> จากกรุงเทพฯ ไปเกาะสีชัง ให้ขึ้นรถจากสถานีเอกมัยไปที่ศรีราชา
                  </p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0" />
                  <p className="text-gray-700">
                    โดยลงรถที่หน้าห้างโรบินสันศรีราชา แล้วต่อรถรับจ้างมาท่าเรือ "เกาะลอย"
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="mt-8"
        >
          <div className="bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-2xl p-8 text-center">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <SafeIcon icon={FiInfo} className="w-8 h-8 text-amber-600" />
              <h3 className="text-2xl font-bold text-amber-900">ข้อสำคัญ</h3>
            </div>
            <div className="space-y-3">
              <p className="text-lg text-amber-800 font-medium">
                กรุณามาถึงจุดนัดพบให้ตรงเวลา เวลา 10:20 น.
              </p>
              <p className="text-amber-700">
                หากมีข้อสงสัยเรื่องการเดินทาง สามารถติดต่อสอบถามล่วงหน้าได้
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TravelDetails;